export default "__VITE_ASSET__Rn9q7zXy__"